import react from "react";

const Footer = () => {
    

    return (
        <div className='footer'>
        <h4>Made by:</h4>
        <a href="https://www.instagram.com/timothybrennanjr/">Timothy Brennan</a>
        <a href="https://amullin.netlify.app/">Lex Mullin</a>
        </div>
    )
}

export default Footer;